import { ActionIcon, Tooltip } from '@mantine/core'
import { useState } from 'react'
import { useNavigate, useParams } from '@tanstack/react-router'
import { TbRobot } from 'react-icons/tb'
import { useTranslation } from 'react-i18next'
import { getAutoScheduleFlags, isAutoScheduleAvailable } from '@/utils/autoScheduleFlags'

export function AutoScheduleButton({
  vehicleId,
  intervalStart,
  intervalEnd,
  size = 'md',
}: {
  vehicleId: string
  intervalStart?: string
  intervalEnd?: string
  size?: 'sm' | 'md'
}) {
  const { t } = useTranslation('scheduling')
  const navigate = useNavigate()
  const params = useParams({ strict: false })
  const startDate = typeof params.startDate === 'string' ? params.startDate : undefined
  const endDate = typeof params.endDate === 'string' ? params.endDate : undefined
  const [tooltipOpened, setTooltipOpened] = useState(false)

  if (!isAutoScheduleAvailable(getAutoScheduleFlags()) || !startDate || !endDate) {
    return null
  }

  return (
    <Tooltip label={t('autoSchedule.autoSchedule')} withArrow position="top" opened={tooltipOpened} zIndex={100}>
      <ActionIcon
        variant="subtle"
        size={size}
        aria-label={t('autoSchedule.autoSchedule')}
        onMouseEnter={() => setTooltipOpened(true)}
        onMouseLeave={() => setTooltipOpened(false)}
        onClick={() => {
          setTooltipOpened(false)
          navigate({
            to: '/scheduling/$startDate/$endDate/auto-schedule/$vehicleId',
            params: { startDate, endDate, vehicleId },
            search: intervalStart && intervalEnd ? { intervalStart, intervalEnd } : {},
          })
        }}
      >
        <TbRobot />
      </ActionIcon>
    </Tooltip>
  )
}
